import { Box, CircularProgress, Divider, Typography } from "@mui/material";
import AddressReportModal from "../AddressReport/AddressReportModal";
import AddAddressButtonSection from "./AddAddressSection/AddAddressButtonSection";
import CampaignAddressesListHeader from "./CampaignAddressesList/CampaignAddressesListHeader";
import CampaignAddressesList from "./CampaignAddressesList/CampaignAddressesList";
import AwarenessCampaignMap from "./CampaignAddressesMap/AwarenessCampaignMap";
import CampaignAddressesDisplayToggle from "./CampaignAddressesDisplayToggle";
import { useAppSelector } from "../../../store/hooks";
import { selectCampaignAddressesIds } from "../../../store/reducers/awareness_campaigns/addresses";
import { useTranslation } from "react-i18next";
import { Namespace } from "../../../locales/translations";
import { CampaignAddressesDisplayMode } from "../../../store/reducers/awareness_campaigns/selected";
import AwarenessCampaignActions from "./AwarenessCampaignActions";
import { BOTTOM_NAVIGATION_HEIGHT_SPACING } from "../../BottomNavigation/BottomNavigationBar";

export default function AwarenessCampaignAddressSection() {
    const { t } = useTranslation([Namespace.ADDRESSES, Namespace.ACTIONS]);

    const addressesLoading = useAppSelector(state => state.awareness_campaign.addresses.loading);
    const hasAdddresses = useAppSelector(state => selectCampaignAddressesIds(state).length > 0);

    const selectedAddressesDisplayMode = useAppSelector(state => state.awareness_campaign.selected.addressesDisplayMode);

    if (addressesLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box display="flex" flexDirection="column" gap={3}>
            <CampaignAddressesDisplayToggle />

            {selectedAddressesDisplayMode === CampaignAddressesDisplayMode.LIST ? ( // display addresses as list
                <Box
                    pb={15} // extra padding to account for "Add address" button
                >
                    {!hasAdddresses ? (
                        <Typography variant="body2" fontStyle="italic" color="text.secondary">
                            {t('no_address_added', { ns: Namespace.ADDRESSES })}
                        </Typography>
                    ) : (
                        <>
                            <CampaignAddressesListHeader />

                            <Divider />

                            <CampaignAddressesList />

                            <AwarenessCampaignActions />
                        </>
                    )}

                    < AddAddressButtonSection />
                </Box>
            ) : ( // display addresses as map
                <Box
                    sx={{
                        // make map fit perfectly in the screen without scrolling
                        height: `calc(100vh - 280px - ${BOTTOM_NAVIGATION_HEIGHT_SPACING}px)`,
                        width: '100%',
                    }}
                >
                    <AwarenessCampaignMap
                        width={1000}
                        height={500}
                        showMapControls
                    />
                </Box>
            )}

            <AddressReportModal />
        </Box>
    );
}